import React from 'react';
import { Text } from '@ui';
/** `dataKey`s from `buildDocumentColumns` that the table may sort on. */
export const SUBCONTRACTOR_SORTABLE_COLUMNS = ['uploaderName'];
/**
 * This surface's one entity column: who uploaded the document.
 *
 * It matters more here than on the other four screens — these rows are routinely created by a
 * SUBCONTRACTOR tenant rather than the host, and the legacy table showed the uploader for exactly
 * that reason. There is deliberately no Document Type column: the table is already grouped by
 * type, so a column repeating the group heading on every row says nothing (plan decision 5).
 */
export function buildDocumentColumns({ translateFn }) {
    return [
        {
            dataKey: 'uploaderName',
            label: translateFn('columns.uploader'),
            width: '220px',
            renderer: ({ item }) => React.createElement(Text, { variant: "body" }, item.uploaderName)
        }
    ];
}
